import { render, staticRenderFns } from "./NumbersSetting.vue?vue&type=template&id=5a565aaa&scoped=true&"
import script from "./NumbersSetting.vue?vue&type=script&lang=js&"
export * from "./NumbersSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a565aaa",
  null
  
)

export default component.exports